import { useToast } from '@cad-arc';
import { useCallback } from 'react';
import { MAX_TOTAL_RESULT_COUNT } from './constants';
import { PaginationContextType } from './use-pagination';

export function useHandleSearchResponse(pagination: PaginationContextType) {
    const toast = useToast();
    return useCallback(
        (totalCount: number | undefined, from: number) => {
            if (totalCount !== undefined) {
                if (totalCount > MAX_TOTAL_RESULT_COUNT) {
                    pagination.setTotalItemCount(MAX_TOTAL_RESULT_COUNT);
                    if (from === 0) {
                        toast({
                            status: 'default',
                            description: `Limiting results to ${MAX_TOTAL_RESULT_COUNT.toLocaleString()} of ${totalCount.toLocaleString()}. Refine search criteria to view all results.`,
                        });
                    }
                } else {
                    pagination.setTotalItemCount(totalCount);
                }
            }
        },
        [pagination, toast]
    );
}
